export default function (context) {
  const { route, $cookies } = context;
  if (route.query && route.query.utm_source){
    $cookies.set('utm_source', route.query.utm_source)
  }
}
